import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { useRouter } from 'hooks/useRouter';
import I18n from 'hooks/useI18n';

import Modal from '../Modal/index';
import MemberButton from 'components/common/buttons/MemberButton';

import './style.scss';
import Img from 'components/common/Img';
import { icNotTickCircle, icTickCircle } from 'redhotpie-shared-lib/themes/ImagesSVG';
import Div from 'components/common/Div';
import { IModalComponentProps } from '../Modal/Modal';
import { phoneDetect } from 'redhotpie-shared-lib/functions/utils';
import { STYLE_MODAL } from 'redhotpie-shared-lib/constants/constants';

interface INotificationModal extends IModalComponentProps {
  classNames?: string;
  isMobile?: boolean;
  headerText?: string;
  content?: any;
  contentSecond?: string;
  contentThird?: string;
  isMoreEndGroupChat?: boolean;
  cancelText?: string;
  okText?: string;
  customClassButton?: string;
  disableCancel?: boolean;
  customClassCancle?: string;
  keepModalWhenClickCancel?: boolean;
  customClassOk?: string;
  isTryLater?: boolean;
  extraFooter?: React.ReactNode;
  autoRunCancel?: boolean;
  setAutoRunCancel?: (value: boolean) => void;
  onCancelClick?: () => void;
}

const NotificationModal = (props: INotificationModal) => {
  const {
    classNames,
    headerText,
    content,
    contentSecond,
    contentThird,
    isMoreEndGroupChat,
    cancelText,
    okText,
    customClassButton,
    disableCancel,
    customClassCancle,
    keepModalWhenClickCancel,
    customClassOk,
    isTryLater,
    extraFooter,
    autoRunCancel,
    setAutoRunCancel,
    onCancelClick,
  } = props;
  const { location, history } = useRouter();
  const refModal = useRef<Modal>(null);
  const isMobile = phoneDetect();
  const [isDeleteAllMessage, setDeleteAllMessage] = useState(true);

  useEffect(() => {
    if (autoRunCancel === true && typeof setAutoRunCancel === 'function') {
      onClickCancel();
      setAutoRunCancel(false);
    }
  }, [autoRunCancel]);

  function closeModal(cb?: () => void) {
    refModal.current?.closeModal(cb);
  }

  const onClickCancel = () => {
    if (keepModalWhenClickCancel) {
      if (typeof onCancelClick === 'function') {
        onCancelClick();
      }
    } else {
      closeModal(() => {
        if (typeof onCancelClick === 'function') {
          onCancelClick();
        }
      });
    }
    setDeleteAllMessage(true);
  };

  const onActionClick = () => {
    const moreData = isMoreEndGroupChat ? { isDeleteAllMessage } : undefined;
    closeModal(() => {
      if (typeof props.onActionClick === 'function') {
        if (isTryLater) {
          props.onActionClick(true);
        } else {
          props.onActionClick(moreData);
        }
      }
      setDeleteAllMessage(true);
    });
  };

  const onActionClickTryAgain = () => {
    if (typeof props.onActionClick === 'function') {
      props.onActionClick(true);
    }
    closeModal();
  };

  const renderNotification = () => {
    return (
      <div
        className={cn('notification-modal', {
          'notification-modal-desktop': !isMobile,
          [classNames || '']: classNames,
        })}>
        {headerText !== '' && <div className="noti-header">{headerText}</div>}
        {content && <div className="noti-content">{content}</div>}
        {contentSecond && <div className="noti-content noti-content-second" dangerouslySetInnerHTML={{ __html: contentSecond }} />}
        {contentThird && <div className="noti-content noti-content-third" dangerouslySetInnerHTML={{ __html: contentThird }} />}
        {isMoreEndGroupChat && (
          <Div className="delete-all-mess" onClick={() => setDeleteAllMessage(prevState => !prevState)}>
            <Img src={isDeleteAllMessage ? icTickCircle : icNotTickCircle} alt="icon-check-delete-all" />
            <span>{I18n.t('EventGroupChat.DeleteMyMessageInThisChat')}</span>
          </Div>
        )}
        {(cancelText || okText) && (
          <div
            className={cn('confirm-section', {
              [customClassButton || '']: customClassButton,
            })}>
            {cancelText && !disableCancel && (
              <MemberButton
                // isTextCapitalize
                text={cancelText}
                className={cn({
                  [customClassCancle || '']: customClassCancle,
                })}
                color={classNames?.includes(STYLE_MODAL.BLOCK_MODAL) ? 'text' : 'outlineGray'}
                onClick={onClickCancel}
              />
            )}
            {okText && (
              <MemberButton
                // isTextCapitalize
                text={okText}
                className={cn({
                  [customClassOk || '']: customClassOk,
                })}
                onClick={isTryLater ? onActionClickTryAgain : onActionClick}
                color="primary"
              />
            )}
          </div>
        )}
        {isTryLater && (
          <div className="btn-try-later">
            <MemberButton text={I18n.t('Btn.TryLater')} onClick={onActionClick} />
          </div>
        )}
        {extraFooter}
      </div>
    );
  };

  return (
    <Modal {...props} location={location} history={history} isRenderCustomBodyContainer ref={refModal} modalName="NotificationModal">
      {renderNotification()}
    </Modal>
  );
};

export default NotificationModal;
